import { Box, BoxProps, Heading } from '@homebotapp/hb-react-component-catalog'

type SidebarGroupProps = BoxProps & {
  title: string
}

export const SidebarGroup = ({ title, children, ...restProps }: SidebarGroupProps) => (
  <Box {...restProps} role='group'>
    <Heading as='h3' size='3xs' textAlign='left' variant='eyebrow' paddingX='3' marginBottom='2' color='neutral.700'>
      {title}
    </Heading>
    <ul>{children}</ul>
  </Box>
)
